const { validateFormField } = require("../../validation/validation");

async function validateVstopSSvetovanjemStrankaPrisotna (
    {
        isValidPotrditvenaKoda,
    },
    model
) {
    let isValid = true;

    const modelCopy = JSON.parse(JSON.stringify(model));
    const fields = [ 
        ...Object.values(modelCopy.zavarovalec),
        ...Object.values(modelCopy.clen545),
    ];

    fields.forEach(field => { field.error = null; });

    for (let item of fields ) {
        const error = await validateFormField(
            (potrditvenaKoda) => isValidPotrditvenaKoda({
                email: model.zavarovalec.email.value,
                mobitel: model.zavarovalec.mobitel.value,
                id: model.zavarovalec.otpId.value,
                potrditvenaKoda,
            }),
            null, 
            item,
            modelCopy,
        );
        if (error.hasError) {
            item.error = error;
            isValid = false;
        }
    }

    fields.forEach(field => {
        Object.keys(field)
            .forEach(key => {
                if (key !== 'error') delete field[key];
            });
    });

    return {
        isValid,
        errors: modelCopy,
    };
}

module.exports = { validateVstopSSvetovanjemStrankaPrisotna };